import React, { FC } from 'react'
import { Typography } from '@dg-shared'
import { useTranslate } from '../../../hooks/shared'
import { makeStyles } from 'tss-react/mui'
import withV4IndexPriority from '../../../styles/withV4IndexPriority'
import { TRANSLATIONS as T } from '../../../constants/translations-constants'
import { CustomClassName } from '../../../types/interface/styles.interface'
import { getDataComponentName, getLocalizedPartnerName } from '@dg-util'
import BrandConfig from 'BrandConfig'

export const useAuthStartegyText = makeStyles()(() =>
  withV4IndexPriority({
    disclaimer: {
      marginTop: 5,
      textAlign: 'center',
      '& a': {
        textDecoration: 'underline',
        color: 'inherit',
      },
    },
  })
)

const AuthDecisionText: FC<CustomClassName> = ({}) => {
  const { classes } = useAuthStartegyText()
  const { t } = useTranslate(T.AUTH)
  const link = BrandConfig.PRIVACY_POLICY_LINK
  const partnerLink = BrandConfig.PARTNER_PRIVACY_POLICY_LINK
  const partnerName = getLocalizedPartnerName()

  return (
    <Typography
      component='span'
      data-componentname={getDataComponentName(__filename)}
      size='small'
      html={true}
      color='textDisclaimer'
      modifiers={['preFormatted']}
      className={classes.disclaimer}
    >
      {t(`description`, { partnerLink, link, partnerName })}
    </Typography>
  )
}

export default AuthDecisionText
